<script lang="ts">
    import { onMount } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import { faEdit, faFileSignature, faTimes } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import type { Service } from '../../modules/posApi/services/service'
    import { ServicesRepository } from '../../modules/posApi/services/services.repository'
    import { ServicesService } from '../../modules/posApi/services/services.service'
    import { AppointmentsRepository } from '../../modules/schedulerApi/appointments/appointments.repository'
    import { AppointmentsService } from '../../modules/schedulerApi/appointments/appointments.service'
    import type { Appointment } from '../../modules/schedulerApi/appointments/appointment'
    import { AppointmentStatus, AppointmentStatusFriendly } from '../../modules/schedulerApi/appointments/appointments.enum'
    import type { User } from '../../modules/usersApi/users/user'
    import { CompaniesRepository } from '../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../modules/usersApi/companies/companies.service'
    import Popover from '../_common/popover.svelte'
    import AppointmentForm from '../agenda/appointment-form.svelte'
    import type { Schedule } from '../../modules/schedulerApi/schedules/schedule'
    import AppointmentSign from '../agenda/appointment-sign.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    // ###############################################################################################################

    export let personId: string

    const rep = new AppointmentsRepository()
    const service = new AppointmentsService(rep)

    let servicesR = new ServicesRepository()
    let servicesS = new ServicesService(servicesR)

    const compR = new CompaniesRepository()
    const compS = new CompaniesService(compR)
    let users: User[] = []

    let show = false
    let showOld = false
    let appointments: Appointment[] = []
    let selected: Appointment = null

    let statusWithNoOnus = [
        AppointmentStatus.agendamento_remarcado,
        AppointmentStatus.agendamento_cancelado_empresa,
        AppointmentStatus.agendamento_cancelado_usuario,
    ]

    function checkOlds(item: Appointment) {
        if (showOld) return true
        const diffMonths = (new Date().getTime() - new Date(item.start).getTime()) / 1000 / 60 / 60 / 24 / 30
        if (diffMonths <= 12) return true
        return false
    }

    async function selectAppointment(id: string) {
        selected = appointments.find((el) => el.appointmentId === id)
    }

    async function loadEntities() {
        try {
            show = true
            const schedules: Schedule[] = await window.api.schedulers.schedules.getAll(
                {
                    excluded: true,
                    appointments: false,
                    all: true,
                    slots: false,
                },
                600,
            )
            appointments = await service.getAll({ personId }, 600)
            let services: Service[] = await servicesS.getAll({ excluded: true }, 600)
            users = await compS.getCompanyUsers(600)
            for (let appointment of appointments) {
                appointment.schedule = schedules.find((el) => el.scheduleId === appointment.scheduleId)
                for (let item of appointment.items) {
                    item.service = services.find((el) => {
                        return el.serviceId === item.serviceId
                    })
                    item.user = users.find((el) => {
                        return el.userId === item.userId
                    })
                }
            }
            selected = null
            console.log('appointments', appointments)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    onMount(async () => {
        await loadEntities()
    })

    let appointmentId = null
    function editAppointment(id: string) {
        appointmentId = id
    }

    function changeAppointment() {
        loadEntities()
    }

    function closeAppointment() {
        appointmentId = null
        selected = null
    }

    let signAppointmentId: string = null
    function goSign(id: string) {
        signAppointmentId = id
    }

    function closeSign() {
        signAppointmentId = null
        loadEntities()
    }
</script>

{#if signAppointmentId}
    <Popover title="Assinatura" width="860px" height="460px" on:close={closeSign}>
        <AppointmentSign on:close={closeSign} appointmentId={signAppointmentId}></AppointmentSign>
    </Popover>
{/if}

{#if appointmentId}
    <Popover
        title="Agendamento"
        width="1080px"
        height="80vh"
        on:close={() => {
            appointmentId = null
        }}
    >
        <AppointmentForm on:change={changeAppointment} on:close={closeAppointment} bind:appointmentId />
    </Popover>
{/if}

<Zframe title="Agendamentos">
    <div class="grid-body mt-2">
        <div class="row mb-2">
            <div class="col d-flex">
                <div class="spacer" />
                <div class="form-check form-switch me-2">
                    <input
                        class="form-check-input"
                        bind:checked={showOld}
                        on:change={() => (appointments = appointments)}
                        type="checkbox"
                        role="switch"
                        id="showDate"
                    />
                    <label class="form-check-label" for="showDate">Exibir agendamentos antigos</label>
                </div>
            </div>
        </div>

        {#if !show}
            <div class="items">
                {#each appointments as item}
                    {#if checkOlds(item)}
                        <div class="box ap-item {item.status}" on:click={() => selectAppointment(item.appointmentId)}>
                            <button
                                title="Assinatura"
                                class="btn-sign"
                                class:signed={item.signed}
                                on:mousedown|stopPropagation
                                on:click|stopPropagation={() => goSign(item.appointmentId)}
                            >
                                <Fa icon={faFileSignature} />
                            </button>
                            <div>
                                {dayjs(item.start).format('DD/MM/YYYY HH:mm')}<br />{AppointmentStatusFriendly[item.status]
                                    .replace(' pelo ', ' ')
                                    .replace(' pela ', ' ')}
                            </div>
                        </div>
                    {/if}
                {/each}
            </div>
            {#if appointments.length === 0}
                <div class="text-muted text-center">Nenhum agendamento realizado</div>
            {/if}
        {/if}

        {#if selected}
            <div class="pop px-2 m-2">
                <div class="row line liner py-1 bg">
                    <div class="col">
                        <span class="badge">Agenda</span>
                        <span class="badge_content">
                            {selected.schedule?.label || ''}
                            {#if selected.schedule?.status === 0}
                                {' (agenda excluída)'}
                            {/if}
                        </span>
                        <span class="badge">Horário</span>
                        <span class="badge_content">
                            {dayjs(selected.start).format('DD/MM/YYYY HH:mm')} até {dayjs(selected.end).format('HH:mm')}
                        </span>
                        <span class="badge">Status</span>
                        <span class="badge_content {selected.status}_color">
                            {AppointmentStatusFriendly[selected.status]}
                        </span>
                    </div>
                    <div class="col-md-2 text-end act">
                        <button
                            class="btn btn-primary btn-sm"
                            on:click={() => {
                                editAppointment(selected.appointmentId)
                            }}
                        >
                            <Fa icon={faEdit} />
                        </button>
                        <button
                            class="btn btn-primary btn-sm"
                            on:click={() => {
                                selected = null
                            }}
                        >
                            <Fa icon={faTimes} />
                        </button>
                    </div>
                    <div class="col-12">
                        <span class="badge">Anotações:</span>
                        <span class="badge_content">{selected.notes || '-'}</span>
                    </div>
                </div>
                <div class="row line liner py-1 text-muted">
                    <div class="col">Atendente</div>
                    <div class="col">Serviço</div>
                </div>
                {#each selected.items as service}
                    <div class="row line liner py-1">
                        <div class="col">{service.user?.userName || '-'}</div>
                        <div class="col">
                            {service.service?.name}
                            {#if service.parentServicesOnInvoicesId}
                                {#if statusWithNoOnus.includes(selected.status)}
                                    <div class="badge badge_secondary">não consumido do saldo</div>
                                {:else}
                                    <div class="badge badge_secondary">consumido do saldo</div>
                                {/if}
                            {/if}
                        </div>
                    </div>
                {/each}
            </div>
        {/if}
    </div>
</Zframe>

<style>
    .items {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
    }

    .box {
        border-radius: 4px;
        cursor: pointer;
        padding: 2px;
        padding-right: 0px;
        font-size: 13px;
        color: white;
        flex: 0 0 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
    }
    .btn-sign {
        position: absolute;
        top: 3px;
        right: 3px;
        width: 26px;
        height: 22px;
        padding: 0px;
        cursor: pointer;
        border: 0px solid #99999999;
        background: #66666666;
        color: white;
    }
    .signed {
        color: #0caa50 !important;
    }
    .pop {
        background: #00000020;
        margin-top: 8px;
    }
    .act {
        display: flex;
        justify-content: flex-end;
    }
    .act .btn {
        margin-left: 4px;
    }
    .badge {
        background-color: #99999940;
    }
    .badge_content {
        padding-right: 16px;
    }

    @media (max-width: 900px) {
        .items {
            gap: 4px;
        }
    }
</style>
